import type { VideoElementData } from "@/types/storyboard";

export const hasPlayableSource = (media?: VideoElementData): boolean => {
  if (media?.provider === "FILE") {
    return !!media.src;
  }

  return !!media?.provider && !!media.videoId;
};
